import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const FONT_MIN = 12
const FONT_MAX = 26
const FONT_DEFAULT = 14
const FONT_STEP = 2
const STORAGE_KEY = 'bible-study-font-size'

export const useUiStore = defineStore('ui', () => {
  const fontSize = ref<number>(
    Number(localStorage.getItem(STORAGE_KEY)) || FONT_DEFAULT
  )

  const toolbarHeight = computed(() => fontSize.value + 16)  // 16px → 32px
  const btnHeight = computed(() => fontSize.value + 8)       // 16px → 24px
  const ctrlBarHeight = computed(() => fontSize.value + 16)  // 16px → 32px

  const canDecrease = computed(() => fontSize.value > FONT_MIN)
  const canIncrease = computed(() => fontSize.value < FONT_MAX)

  function decrease() {
    if (!canDecrease.value) return
    fontSize.value -= FONT_STEP
    persist()
  }

  function reset() {
    fontSize.value = FONT_DEFAULT
    persist()
  }

  function increase() {
    if (!canIncrease.value) return
    fontSize.value += FONT_STEP
    persist()
  }

  function persist() {
    localStorage.setItem(STORAGE_KEY, String(fontSize.value))
  }

  function syncFromServer(size: number) {
    if (size >= FONT_MIN && size <= FONT_MAX) {
      fontSize.value = size
      persist()
    }
  }

  const isDefault = computed(() => fontSize.value === FONT_DEFAULT)

  return { fontSize, toolbarHeight, btnHeight, ctrlBarHeight, canDecrease, canIncrease, decrease, reset, increase, syncFromServer, isDefault }
})
